'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _document = require('../../constants/actions/document');

var _queryDocumentsSaga = require('./queryDocumentsSaga');

var _getDocumentSaga = require('./getDocumentSaga');

var _upsertDocumentSaga = require('./upsertDocumentSaga');

var _deleteDocumentSaga = require('./deleteDocumentSaga');

var _findDocumentSaga = require('./findDocumentSaga');

var _queryShareableDocumentsSaga = require('./queryShareableDocumentsSaga');

var _shareUnshareDocumentsSaga = require('./shareUnshareDocumentsSaga');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchQueryDocuments),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetDocument),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchFindDocument),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchUpsertDocument),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteDocument),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchQueryShareableDocuments),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchShareUnshareDocuments),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(root);

function watchQueryDocuments() {
    return regeneratorRuntime.wrap(function watchQueryDocuments$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.takeLatest)(_document.QUERY_DOCUMENTS, _queryDocumentsSaga.queryDocumentsSaga);

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetDocument() {
    return regeneratorRuntime.wrap(function watchGetDocument$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_document.GET_DOCUMENT, _getDocumentSaga.getDocumentSaga);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function watchFindDocument() {
    return regeneratorRuntime.wrap(function watchFindDocument$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.takeLatest)(_document.FIND_DOCUMENT, _findDocumentSaga.findDocumentSaga);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchUpsertDocument() {
    return regeneratorRuntime.wrap(function watchUpsertDocument$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_document.UPSERT_DOCUMENT, _upsertDocumentSaga.upsertDocumentSaga);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function watchDeleteDocument() {
    return regeneratorRuntime.wrap(function watchDeleteDocument$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_document.DELETE_DOCUMENT, _deleteDocumentSaga.deleteDocumentSaga);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchQueryShareableDocuments() {
    return regeneratorRuntime.wrap(function watchQueryShareableDocuments$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_document.QUERY_SHAREABLE_DOCUMENTS, _queryShareableDocumentsSaga.queryShareableDocumentsSaga);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function watchShareUnshareDocuments() {
    return regeneratorRuntime.wrap(function watchShareUnshareDocuments$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_document.SHARE_UNSHARE_DOCUMENTS, _shareUnshareDocumentsSaga.shareUnshareDocumentsSaga);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function root() {
    return regeneratorRuntime.wrap(function root$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(watchQueryDocuments), (0, _effects.fork)(watchGetDocument), (0, _effects.fork)(watchFindDocument), (0, _effects.fork)(watchUpsertDocument), (0, _effects.fork)(watchDeleteDocument), (0, _effects.fork)(watchQueryShareableDocuments), (0, _effects.fork)(watchShareUnshareDocuments)]);

                case 2:
                    return _context8.abrupt('return', _context8.sent);

                case 3:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = root;